import { transparentize } from 'polished'
import styled, { css } from 'styled-components'

export const CatalogItemDetailsThumbnailStyled = styled.button<{
  $isSelected: boolean
}>`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.typography.pxToRem(48)};
  height: ${(props) => props.theme.typography.pxToRem(48)};
  padding: ${(props) => props.theme.typography.pxToRem(2)};
  border: ${(props) => props.theme.typography.pxToRem(1)} solid
    ${(props) => props.theme.colors.globalCommand.border};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};
  background: ${(props) => transparentize(0.95, props.theme.colors.darkGreen)};
  cursor: pointer;
  overflow: hidden;

  ${(props) =>
    props.$isSelected &&
    css`
      border-color: ${props.theme.colors.darkGreen};
      border-width: ${props.theme.typography.pxToRem(2)};
    `}

  &:focus-visible {
    outline: ${(props) => props.theme.typography.pxToRem(2)} solid
      ${(props) => props.theme.colors.focus};
    outline-offset: ${(props) => props.theme.typography.pxToRem(2)};
  }
`
